import { useAppSelector, useDeviceType } from 'app/hooks'
import { CashlessHospitalCard } from 'Core/Cards/CashlessHospitalCard'
import {
  useLazyGetCashlessHospitalsListingQuery,
  useLazyGetPincodeListingQuery,
} from 'Services/API/health.api'
import { useEffect, useState } from 'react'
import { IHealthPincode, IHealthPincodeOption } from 'Models/ResponseModels/Health'
import {
  Button,
  Flex,
  Box,
  FormLabel,
  Center,
  Divider,
  FormErrorMessage,
  FormControl,
  Grid,
  GridItem,
} from '@chakra-ui/react'
import { TextInput } from 'Core/TextInput'
import { AsyncSelect, Select, SingleValue } from 'chakra-react-select'
import {
  onlyAllowTypingAlphabet,
  onlyAllowTypingNumbers,
  pincodeLabelFormatterHealth,
} from 'Services/general'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { MemberData } from 'Models/Common/Health.General'
import { ToastService } from 'Services/toast.service'
// import { getValue } from '@testing-library/user-event/dist/types/utils'

const hospitalsDataSchema = yup.object().shape({
  pincode: yup.string().required('Pincode is required!'),
  hospital_name: yup.string(),
})

export const CashlessModalDesktop = ({ insuranceId }: { insuranceId: string }) => {
  // ------------------------------ Variables ------------------------------

  //  ------------------------------ App Hooks  ------------------------------
  const { isDesktop ,isMobile,isTablet} = useDeviceType()
  const { proposer } = useAppSelector((state) => state.memberDetails)

  // ------------------------------ API Calls  ------------------------------

  const [cashlessHospitalsData, { data: hospitalsData, isFetching: hospitalsDataFetching }] =
    useLazyGetCashlessHospitalsListingQuery()
  const [getPincode] = useLazyGetPincodeListingQuery()

  //  ------------------------------ Local States ------------------------------

  const [pincode, setPincode] = useState<IHealthPincode>()
  // const [proposerPincode, setProposerPincode] = useState<IHealthPincodeOption>()

  const [pincodeInput, setPincodeInput] = useState('')

  //  ------------------------------ Functions ------------------------------

  // const handlePincodeSelectChange = (selectedPincode: SingleValue<IHealthPincode>) => {
  //   if (selectedPincode?.pincode) {
  //     const selected = {
  //       ...selectedPincode,
  //       label: selectedPincode.pincode.toString(),
  //       value: selectedPincode.pincode.toString(),
  //     }
  //     setPincode(selected)
  //     setProposerPincode(selected)
  //     // console.log(pincode, proposerPincode, 'pincodes')
  //     setValue('pincode', selected.pincode)
  //     clearErrors('pincode')
  //   }
  // }
  // const loadPincodeOptions = (
  //   inputSearchValue: string,
  //   callback: (options: IHealthPincodeOption[]) => void,
  // ) => {
  //   if (inputSearchValue.length ==6) {
  //     getPincode({
  //       pincode: inputSearchValue,
  //       insurance_id: parseInt(insuranceId),
  //     }).then((resp) => {
  //       const pincodes = resp.data?.result
  //       if (pincodes) callback(pincodeLabelFormatterHealth(pincodes))
  //     })
  //   }
  // }

  const onFormSubmit = () => {
    // console.log('on Submit called')

    // if (
    //   proposerPincode?.pincode.toString() != '' ||
    //   getValues('pincode') ||
    //   proposer.pincode.toString() != ''
    // ) {
      // console.log(getValues('pincode'), proposer.pincode.toString(), 'pincode found')
      cashlessHospitalsData({
        insurance_id: parseInt(insuranceId),
        pincode:getValues('pincode'),
        hospital_name: getValues('hospital_name'),
      })
    // } else {
    //   setError('pincode', { type: 'custom', message: 'Select Pincode' })
    //   return
    // }
    // if (Object.keys(errors).length) {
    //   return
    // }
  }
  const onFormError = (errors: any) => {
    console.log(errors, 'errors in form')
  }

  // ------------------------------   Schemas ------------------------------------------------------------

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    watch,
    formState: { errors },
    getValues,
    setError,
  } = useForm({
    resolver: yupResolver(hospitalsDataSchema),
    defaultValues: {
      // pincode:memberData.pincode_map.pincode,
      pincode: proposer.pincode,
      hospital_name: '',
    },
  })

  // ------------------------------  Use Effects  ------------------------------

  useEffect(() => {
    cashlessHospitalsData({
      insurance_id: parseInt(insuranceId),
      pincode: proposer.pincode,
      hospital_name: getValues('hospital_name'),
    })
    
  }, [])

  // useEffect(() => {
  //   if (proposer.pincode.toString().length === 6) {
  //     getPincode({
  //       pincode: proposer.pincode,
  //     })
  //       .unwrap()
  //       .then((resp) => {
  //         const pincodes = resp.result
  //         console.log(resp, 'pincode resp')
  //         if (pincodes && pincodes.length) {
  //           setProposerPincode({
  //             value: `${pincodes[0].area_name}(${pincodes[0].pincode})`,
  //             label: pincodes[0].pincode.toString(),
  //             ...pincodes[0],
  //           })
  //         }
  //       })
  //       .catch((error) => {
  //         console.log(error, 'in catch')
  //       })
  //   }
  // }, [proposer.pincode])
  return (
    <>
      <Flex fontSize='16px' gap='0' direction={isDesktop ? 'row' : 'column'}>
        <Box >
          {/* form section */}
          <Flex direction='column'>
            <Box
              fontSize='md'
              // fontWeight='bold'
              paddingY='4'
              boxShadow={isDesktop ? '' : 'lg'}
              textAlign={'center'}
              borderBottom='1px'
            >
              Locate Cashless Hospitals Near You
            </Box>
            <Box paddingX={isDesktop ? '2' : ''}>

            <form onSubmit={handleSubmit(onFormSubmit, onFormError)}>
                <Flex direction={'column'} gap='4' padding='4'>
                <Box  w={isDesktop ? '250px' : ''}>
                  <FormControl isInvalid={errors.pincode ? true : false}>
                    <FormLabel fontSize='14px' fontWeight='bold'>
                      Pin Code
                    </FormLabel>
                    {/* <AsyncSelect
                      className='w-full'
                      placeholder='Select Pincode'
                      onInputChange={(input) => {
                        if (input.length < 7) setPincodeInput(input)
                      }}
                      inputValue={pincodeInput}
                      {...register('pincode')}
                      onKeyDown={onlyAllowTypingNumbers}
                      loadOptions={loadPincodeOptions}
                      onChange={handlePincodeSelectChange}
                      value={proposerPincode}
                      defaultInputValue={proposer?.pincode.toString()}
                      // isDisabled={proposer.pincode ? true : false}
                      onMenuOpen={() => { 
                        setPincodeInput('')
                        setProposerPincode({
                          area_name: '',
                          city_name: '',
                          pincode: '',
                          state_name: '',
                          area_code: '',
                          area_id: null,
                          city_code: '',
                          extra_info: '',
                          id: null,
                          is_district: false,
                          is_insurance_wise: false,
                          state_code: '',
                          city_id: '',
                          label: '',
                          value:''
                        })
                        setValue('pincode','')
                      }}
                    /> */}
                      <TextInput
                        placeholder='Enter Pincode'
                        maxLength={6}
                        {...register('pincode')}
                        onKeyDown={onlyAllowTypingNumbers} />
                    {errors.pincode && (
                      <FormErrorMessage>{errors.pincode?.message?.toString()}</FormErrorMessage>
                    )}
                  </FormControl>
                </Box>

                <FormControl isInvalid={errors.hospital_name ? true : false}>
                  <Flex direction='column' marginY='2'>
                    <FormLabel fontSize='14px' fontWeight='bold'>
                      Hospital Name
                    </FormLabel>
                    <TextInput
                      placeholder='Enter Hospital Name'
                      {...register('hospital_name')}
                      onKeyDown={onlyAllowTypingAlphabet}
                    />
                  </Flex>
                </FormControl>
                <Center >
                  <Button
                      backgroundColor='primary'
                      color='white'
                      variant='solid'
                      rounded='md'
                      type='submit'
                      w='70%'
                      isLoading={hospitalsDataFetching}
                      isDisabled={watch('pincode') || watch('hospital_name') ? false : true}  
                  >
                    Search
                  </Button>
                </Center>
              </Flex>
            </form>
            </Box>
          </Flex>
        </Box>
        {/* divider */}
        <Box>
          <Divider orientation={isDesktop?'vertical':'horizontal'} borderColor='#D8D8D8' />
        </Box>
        {/* hospitals section */}
        {hospitalsData?.cash_less_hospitals_data &&
        hospitalsData?.cash_less_hospitals_data.length > 0 ? (
          <Box>
            <Box
              fontSize='md'
              // fontWeight='bold'
              padding='4'
              boxShadow={isDesktop ? '' : 'lg'}
              borderBottom='1px'
              textAlign={isDesktop ? 'left' : 'center'}
            >
              Cashless Hospitals
            </Box>
            <Grid  padding={'4'}  templateColumns={isDesktop?'repeat(3, 1fr)':isTablet?'repeat(2,1fr)':'repeat(1,1fr)'} maxH={'60vh'} overflowY={'scroll'}>
              {hospitalsData?.cash_less_hospitals_data.map((hospital, index) => {
                return (
                  <GridItem key={index}>
                    <CashlessHospitalCard
                      name={hospital.hospital_name}
                      address={hospital.hospital_address}
                      id={index}
                    />
                  </GridItem>
                )
              })}
            </Grid>
          </Box>
        ) : (
          <Flex alignItems={'center'} justifyContent={'center'}>
            <Box fontSize='md' fontWeight='bold' padding='4' textAlign={'center'} w='500px'>
              No Hospitals Found!
            </Box>
          </Flex>
        )}
      </Flex>
    </>
  )
}
